





















import { Component, Vue } from "vue-property-decorator";
import { Auth } from "aws-amplify";
@Component
export default class UserMenu extends Vue {
  userName = "";

  created(): void {
    this.getUserName();
  }

  async getUserName(): Promise<void> {
    const r = await Auth.currentUserInfo();
    this.userName = r.attributes.email;
  }

  onClick(): void {
    console.log("click");
  }

  async logout(): Promise<void> {
    await Auth.signOut();
    this.$router.push({ name: "login" });
  }
}
